import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'filteredList': [],
  'dealerInfo': {},
  'loadingAgencies': false,
  'agenciesList': [],
  'agencies': [],
  'filteredAgencies': [],
  'agenciesFilters': {'code': '', 'dealer': ''},
};

const filterAgencies = (agencies, filters) => {
  const {code, dealer} = filters;

  return agencies.filter((agency) => {
    return agency.dealerName.includes(dealer) && (agency.code.includes(code) || agency.description.includes(code));
  });
};

const handleAgenciesFiltering = (state, {field, value}) => {
  if (!field) {
    return {
      'filteredAgencies': state.agencies,
      'agenciesFilters': {'code': '', 'dealer': ''},
    };
  }
  
  const agenciesFilters = {...state.agenciesFilters, [field]: value};

  return {
    agenciesFilters,
    'filteredAgencies': filterAgencies(state.agencies, agenciesFilters),
  };
};

export const dealer = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_DEALERS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_DEALERS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'filteredList': action.response.data,
    }),
    [ActionTypes.FETCHED_DEALERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'filteredList': [],
    }),
    [ActionTypes.FETCHING_DEALER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_DEALER]: (state, action) => ({
      ...state,
      'loading': false,
      'dealerInfo': action.response.data,
    }),
    [ActionTypes.FETCHED_DEALER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'dealerInfo': {},
    }),
    [ActionTypes.FETCHING_AGENCIES_BY_DEALER]: (state, action) => ({
      ...state,
      'loadingAgencies': true,
    }),
    [ActionTypes.FETCHED_AGENCIES_BY_DEALER]: (state, action) => ({
      ...state,
      'loadingAgencies': false,
      'agenciesList': action.response.data,
    }),
    [ActionTypes.FETCHED_AGENCIES_BY_DEALER_FAILED]: (state, action) => ({
      ...state,
      'loadingAgencies': false,
      'agenciesList': [],
    }),
    [ActionTypes.GET_ALL_AGENCIES_REQUEST]: (state, action) => ({
      ...state,
      'loadingAgencies': true,
    }),
    [ActionTypes.GET_ALL_AGENCIES_SUCCESS]: (state, action) => ({
      ...state,
      'loadingAgencies': false,
      'agencies': action.response.data,
      'filteredAgencies': action.response.data,
    }),
    [ActionTypes.GET_ALL_AGENCIES_FAILED]: (state, action) => ({
      ...state,
      'loadingAgencies': false,
      'agencies': [],
      'filteredAgencies': [],
    }),
    [ActionTypes.CHANGE_DEALERS_AGENCIES_FILTER]: (state, action) => ({
      ...state,
      ...handleAgenciesFiltering(state, action.payload),
    }),
    [ActionTypes.CLEAR_AGENCIES_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
  })(state, action);
};
